/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { BankAccountActivityAppliedBy } from './bank-account-activity-applied-by';

/**
 * 
 * @export
 * @interface BankAccountActivity
 */
export interface BankAccountActivity {
    /**
     * 
     * @type {string}
     * @memberof BankAccountActivity
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountActivity
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountActivity
     */
    'organizationName': string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountActivity
     */
    'type': BankAccountActivityTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof BankAccountActivity
     */
    'status': BankAccountActivityStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof BankAccountActivity
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountActivity
     */
    'supplierName': string;
    /**
     * 
     * @type {number}
     * @memberof BankAccountActivity
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof BankAccountActivity
     */
    'pointAmount': number | null;
    /**
     * 
     * @type {number}
     * @memberof BankAccountActivity
     */
    'balance': number | null;
    /**
     * 
     * @type {number}
     * @memberof BankAccountActivity
     */
    'pointBalance': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof BankAccountActivity
     */
    'isConfirmed': boolean;
    /**
     * 
     * @type {string}
     * @memberof BankAccountActivity
     */
    'appliedAt': string | null;
    /**
     * 
     * @type {BankAccountActivityAppliedBy}
     * @memberof BankAccountActivity
     */
    'appliedBy': BankAccountActivityAppliedBy;
    /**
     * 
     * @type {string}
     * @memberof BankAccountActivity
     */
    'executedAt': string | null;
}

export const BankAccountActivityTypeEnum = {
    payBill: 'PAY_BILL',
    deposit: 'DEPOSIT',
    withdrawal: 'WITHDRAWAL',
    reward: 'REWARD',
    usageFee: 'USAGE_FEE',
    point: 'POINT',
    cardPoint: 'CARD_POINT',
    campaignPoint: 'CAMPAIGN_POINT',
    card: 'CARD',
    depositFromGuaranteeMoney: 'DEPOSIT_FROM_GUARANTEE_MONEY',
    withdrawalToGuaranteeMoney: 'WITHDRAWAL_TO_GUARANTEE_MONEY',
    serviceCharge: 'SERVICE_CHARGE'
} as const;

export type BankAccountActivityTypeEnum = typeof BankAccountActivityTypeEnum[keyof typeof BankAccountActivityTypeEnum];
export const BankAccountActivityStatusEnum = {
    reserved: 'RESERVED',
    requestingExternalAccountTransfer: 'REQUESTING_EXTERNAL_ACCOUNT_TRANSFER',
    completed: 'COMPLETED',
    insufficientBalance: 'INSUFFICIENT_BALANCE',
    uploaded: 'UPLOADED',
    readCompleted: 'READ_COMPLETED',
    awaitingApproval: 'AWAITING_APPROVAL',
    approved: 'APPROVED',
    transferCompleted: 'TRANSFER_COMPLETED',
    readError: 'READ_ERROR',
    transferFailed: 'TRANSFER_FAILED',
    approvalExpired: 'APPROVAL_EXPIRED',
    approvalRejected: 'APPROVAL_REJECTED',
    otherError: 'OTHER_ERROR',
    pending: 'PENDING'
} as const;

export type BankAccountActivityStatusEnum = typeof BankAccountActivityStatusEnum[keyof typeof BankAccountActivityStatusEnum];


